
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/i/[...slug]",
      function () {
        return require("private-next-pages/i/[...slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/i/[...slug]"])
      });
    }
  